import {useState} from 'react';
import type {z} from 'zod';
import type {OfficeGalleryPicturesSchema} from '../../../../../core/entities/companyDetail/schema';

type Props = {
  companyName: string;
  officeGallerys?: z.infer<typeof OfficeGalleryPicturesSchema>;
};

export const CompanyOfficeGallery: React.FC<Props> = ({
  companyName,
  officeGallerys,
}) => {
  const [imageURL, setImageURL] = useState(officeGallerys?.[0]?.imageURL);
  const [caption, setCaption] = useState(officeGallerys?.[0]?.caption);
  // オフィスギャラリーがない場合は表示しない
  if (officeGallerys?.length === 0) {
    return null;
  }

  return (
    <div className="rounded-b-[12px] rounded-t-[4px] bg-white p-16 mt-8">
      <div className="flex flex-col items-center mx-auto pc:w-[714px]">
        <div className="flex flex-col items-center">
          <img
            src={imageURL}
            alt={`${companyName}のオフィス風景`}
            className="rounded-16 border border-solid border-line-1 pc:w-[714px] pc:h-[508px] object-cover"
          />
          <p className="mt-16">{caption}</p>
        </div>
        <div className="grid grid-cols-3 w-full gap-8 pc:gap-24 pc:mt-24">
          {officeGallerys?.map((og) => {
            return (
              <button
                type="button"
                className="rounded-16"
                key={og.imageURL}
                onClick={() => {
                  setImageURL(og.imageURL);
                  setCaption(og.caption);
                }}
              >
                {og.imageURL && (
                  <img
                    src={og.imageURL}
                    alt={`${companyName}のオフィス風景`}
                    className="rounded-16 border border-solid border-line-1 h-[60px] w-full pc:h-[134px] object-cover cursor-pointer"
                  />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
